var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2455_19625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2455_19625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.54998 17.275C9.43332 17.275 9.32098 17.254 9.21298 17.212C9.10432 17.1707 9.00832 17.1083 8.92498 17.025L4.74998 12.85C4.59998 12.7 4.52898 12.5207 4.53698 12.312C4.54565 12.104 4.61665 11.925 4.74998 11.775C4.89998 11.625 5.07932 11.55 5.28798 11.55C5.49598 11.55 5.66665 11.625 5.79998 11.775L9.54998 15.525L18.2 6.87499C18.3333 6.72499 18.5083 6.64999 18.725 6.64999C18.9417 6.64999 19.1167 6.72499 19.25 6.87499C19.4 7.02499 19.475 7.20399 19.475 7.41199C19.475 7.62066 19.4 7.79999 19.25 7.94999L10.175 17.025C10.0917 17.1083 9.99598 17.1707 9.88798 17.212C9.77932 17.254 9.66665 17.275 9.54998 17.275Z",
    fill: "#1DA687"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen);
export default __webpack_public_path__ + "static/media/tick-green.109201c72138d0946cdf6125fc1e8a71.svg";
export { ForwardRef as ReactComponent };